import { gql } from '../../__generated'

export const GetDeviceCategories = gql(/* GraphQL */ `
  query GetAvailableCategories($buildingId: ID!) {
    getAvailableCategories(buildingId: $buildingId)
  }
`)
